import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    executions: {},
    flowExecutedOnLoad: []
};
const executionSlice = createSlice({
    name: 'flowExecutions',
    initialState,
    reducers: {
        addExecution: (state, action) => {
            state.executions[action.payload.executionId] = { stepId: action.payload.stepId, feFlowId: action.payload.feFlowId, previousStepId: action.payload.previousStepId };
        },
        removeExecution: (state, action) => {
            delete state.executions[action.payload];
        },
        addExecutedOnLoad: (state, action) => {
            //check if already exists
            if (state.flowExecutedOnLoad.indexOf(action.payload) === -1)
                state.flowExecutedOnLoad.push(action.payload);
        }
    },
});
const { addExecution, removeExecution, addExecutedOnLoad } = executionSlice.actions;
function selectExecutionById(state, executionId) {
    return state.flowExecutions.executions[executionId];
}
function selectAddedExecutedOnLoad(state) {
    return state.flowExecutions.flowExecutedOnLoad;
}
var executionReducer = executionSlice.reducer;

export { addExecutedOnLoad, addExecution, executionReducer as default, executionSlice, removeExecution, selectAddedExecutedOnLoad, selectExecutionById };
//# sourceMappingURL=executionSlice.js.map
